import { Injectable, inject } from '@angular/core';
import {
    CanActivateChildFn,
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { ReferralsService } from '@app/core/services/referrals.service';

@Injectable({
    providedIn: 'root',
})
export class ReferralUrlCleanupGuardService {
    public constructor(
        private readonly referralsService: ReferralsService,
        private readonly router: Router,
    ) {}

    public canActivateChild(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean | UrlTree {
        const cleanedUrl: string = this.referralsService.extractReferralIdFromUrlParams(state.url);

        if (cleanedUrl === state.url) {
            return true;
        }

        return this.router.parseUrl(cleanedUrl);
    }
}

export const referralUrlCleanupGuard: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): boolean | UrlTree => {
    return inject(ReferralUrlCleanupGuardService).canActivateChild(route, state);
};
